import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useLedgerAuditLog = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["accounting_audit_log", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("accounting_audit_log")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(200);
      if (error) throw error;
      return data ?? [];
    },
    enabled: !!user,
  });
};
